import { Entity } from '@backstage/catalog-model';

// Prefix used by InnovationsandboxProvider (catalog-backend-module-innovationsandbox)
// for every annotation it puts on aws-sandbox-lease/-account/-template Resource entities.
const SANDBOX_ANNOTATION_PREFIX = 'sandbox.aws.com/';

export function sandboxAnnotation(entity: Entity, key: string): string | undefined {
  return entity.metadata.annotations?.[`${SANDBOX_ANNOTATION_PREFIX}${key}`] || undefined;
}

export function isResourceOfType(entity: Entity, type: string): boolean {
  return (
    entity.kind.toLowerCase() === 'resource' &&
    (entity.spec as { type?: string } | undefined)?.type === type
  );
}

export function formatDate(value: string): string {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
}

export interface MetadataField {
  label: string;
  key: string;
  format?: (value: string) => unknown;
}

export function buildMetadata(entity: Entity, fields: MetadataField[]): Record<string, unknown> {
  const metadata: Record<string, unknown> = {};
  for (const { label, key, format } of fields) {
    const value = sandboxAnnotation(entity, key);
    if (value !== undefined) {
      metadata[label] = format ? format(value) : value;
    }
  }
  return metadata;
}
